<template>
  <div>
    <Modal class="top" v-model="visible" :title="title" :mask-closable="false" :footer-hide="true">
      <div class="title" v-if="articleIdList.length>1">
        将
        <span>{{ articleIdList.length }}</span>
        张海报导入至：
      </div>
      <Form ref="form" :model="formData" :label-width="80" class="formGauge">
        <FormItem label="分类" prop="columnIds" :rules="$units.formRule.arrRequired('请选择分类', 'change')">
          <selectTreeOld
            :data="columnList"
            :multiple="true"
            :size="null"
            placeholder="请选择"
            :single="true"
            :showParentNode="true"
            :selectAllChildren="false"
            v-model="formData.columnIds"
          ></selectTreeOld>
        </FormItem>

        <FormItem label="展示机构" prop="orgIdList" :rules="$units.formRule.arrRequired('请选择展示机构', 'change')">
          <selectTree
            v-model="formData.orgIdList"
            :multiple="true"
            :maxTagCount="5"
            type="4"
            ref="selectTreeRef"
            :orgId="formData.buzOrganId"
            @treeClick="treeClick"
            :checkChild="false"
            @getTreeData="getTreeData"
            :showCloseIcon="false"
          ></selectTree>
        </FormItem>
      </Form>

      <div class="ivu-modal-footer">
        <Button type="primary" @click="visible = false" ghost>取消</Button>
        <Button type="primary" @click="submit" :loading="loading">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import selectTreeOld from '@/components/commons/selectTree';
import selectTree from '@/components/system/selectTree3';
export default {
  components: {
    selectTreeOld,
    selectTree
  },
  data() {
    return {
      visible: false,
      title: '',
      formData: {
        columnIds: []
      },
      columnList: [],
      treeData: [], //单独设置机构树
      articleIdList:[],
      loading: false
    };
  },
  methods: {
    open(item, ids) {
      this.visible = true;
      this.formData = {
        columnIds: []
      };
      this.title = item.id?`将海报《${item.title}》导入至`:`批量导入`;
      this.data = item;
      this.articleIdList = ids;
      this.$refs.form && this.$refs.form.resetFields();
      this.getColumnList();
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      });
    },

    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.$http({
            url: '/buz/cms/materialsLibrary/article/import',
            type: "POST",
            data: {
              articleIdList: this.articleIdList,
              columnId: this.formData.columnIds,
              orgList: this.formData.orgIdList,
              isUse: 1,
              isAll: this.isAll?1:0
            }
          }).then(res => {
            this.visible = false
            this.$emit('success');
            this.$notice.success("导入成功");
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },

    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    deepCheck(treeData) {
      treeData.forEach(item => {
        item.checked = true;
        if (item.children.length) {
          this.deepCheck(item.children);
        }
      });
    },
    // 权限勾选
    treeClick(data) {
      if (data.checked) {
        if (this.treeData[0].id != data.id) {
          //当前节点不是顶级的直接子级
          this.findTreeParent(this.treeData, data.parentId);
        }
        this.findTreeList([data], true); //勾选子级
      } else {
        this.findTreeList([data], false); //去掉子级勾选
      }
      this.$refs.selectTreeRef.setSelectIdByChecked();
    },
    findTreeParent(tree, id) {
      tree.find(item => {
        if (item.id == id) {
          this.$set(item, 'checked', true);
          if (!item.isTop) {
            //存在非顶级继续查找
            return this.findTreeParent(this.treeData, item.parentId);
          } else {
            return true;
          }
        }
        if (item.children && item.children.length) {
          return this.findTreeParent(item.children, id);
        }
        return false;
      });
    },
    findTreeList(tree, checked) {
      tree.forEach(item => {
        this.$set(item, 'checked', checked);
        if (item.children && item.children.length) {
          this.findTreeList(item.children, checked);
        }
      });
    },
    getColumnList() {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: 'POST',
        data: {
          type: 2,
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 13px;
}
.title {
  color: #3C464F;
  font-size: 13px;
  margin-bottom: 5px;
  display: flex;
  span {
    color: #236DFF;
    display: block;
    margin: 0 3px;
    font-weight: bold;
  }
}
</style>
